import React, { Suspense, useEffect, useState } from 'react'
import { GetAllTopics, SaveTopics, deleteTopics, updateTopics } from '../../../services/CommonService'
import { ToastContainer, toast } from 'react-toastify'
import { Button, Table, Modal } from "react-bootstrap";
import SubTopics from './SubTopics';

function Topics({ topicprops }) {

    const notifyTopFullWidth = (message) => {
        toast.info(message, {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        });
    };

    const fields = {
        name: '',
        status: '',
        position: '',
        subjectid: topicprops.id
    }
    const errors = {
        name: '',
        status: '',
        position: '',
    }
  const [subadminbar, setSubAdminbar] = useState(true);


    useEffect(() => {
        getAllTopic()
        const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
        // console.log("constuserdetails",constuserdetails.roles[0]);
        if (constuserdetails?.roles[0] == 'ROLE_SUBADMIN'  ) {
            setSubAdminbar(false)
          }

    }, [])
    const [formfields, setFromFields] = useState(fields);
    const [errorFields, setErrorFields] = useState(errors);
    const [topic, setTopic] = useState([]);
    const [postModal, setPostModal] = useState(false);
    const [subTopicData,setSubTopicData]=useState({})

    const { name, status, position } = formfields

    const getAllTopic = async () => {
        const reqdata = {
            pageno: '-1',
            query: { subjectid: topicprops.id }
        }
        const ResponseData = await GetAllTopics(reqdata)
        // console.log("Topics resp", ResponseData.data)
        setTopic(ResponseData.data)

    }

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFromFields((prevState) => ({
            ...prevState,
            [name]: value
        }));

    }

    const validateForm = async () => {
        let fields = formfields;
        let errors = {};
        let formIsValid = true;

        if (!fields["position"]) {
            formIsValid = false;
            errors["position"] = "*Please enter display position name .";
        }

        if (!fields["name"]) {
            formIsValid = false;
            errors["name"] = "*Please enter Topic name .";
        }
        if (!fields["status"]) {
            formIsValid = false;
            errors["status"] = "*Please select status .";
        }

        setErrorFields(errors)
        return formIsValid;

    }
    const submitForm = async () => {
        // console.log("formfields", formfields);
        const isValid = await validateForm();
        if (isValid) {
            if (!formfields.id) {
                //save
                const Response = await SaveTopics(formfields);
                if (Response.data.id) {
                    notifyTopFullWidth("Data saved successfully");
                    getAllTopic()
                    setFromFields(fields);
                }

            } else {
                //update
                const Response = await updateTopics(formfields);
                if (Response.data.id) {
                    notifyTopFullWidth("Data updated successfully");
                    getAllTopic()
                }
            }
        }

    }
    const updateRecord = async (item) => {
        setFromFields(item);

    }

    const openModal = async (item) => {
        setSubTopicData(item)
        setPostModal(true)

    }
    const deleteRecord = async (item) => {
        const Response = await deleteTopics(item);
        // console.log("Delete resp",Response.data);
        if (Response.data?.id) {
            notifyTopFullWidth("Data deleted successfully");
            getAllTopic()
        }


    }
    const closemodal=async()=>{
        setPostModal(false)
    }



    return (
        <>

            <ToastContainer
                position="top-center"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />

            <div className="row">
                <div className="form-group mb-3 col-md-3">
                    <label>Display Position</label>
                    <input component="input"
                        placeholder="display position"
                        name="position"
                        className="form-control"
                        value={position} maxLength={50} onChange={handleChange} />

                    <div className="errorMsg">{errorFields.position}</div>
                </div>
                <div className="form-group mb-3 col-md-3">
                    <label>Topic Name</label>
                    <input component="input"
                        placeholder="Topic Name"
                        name="name"
                        className="form-control"
                        value={name} maxLength={50} onChange={handleChange} />
                    <div className="errorMsg">{errorFields.name}</div>
                </div>
                <div className="form-group mb-3 col-md-3">
                    <label>Status</label>
                    <select
                        className="form-control" name='status'
                        onChange={handleChange} value={status}>
                        <option value="">Select Status</option>
                        <option value="Active">Active</option>
                        <option value="Inactive">Inactive</option>
                    </select>
                    <div className="errorMsg">{errorFields.status}</div>
                </div>
                <div className="form-group mb-3 col-md-3">
                    <Button onClick={submitForm} className="me-2" variant="info">
                        Save Topic
                    </Button>

                </div>


            </div>

            <Table responsive>
                <thead>
                    <tr>
                        <th className="width80">
                            <strong>Display Position</strong>
                        </th>
                        <th>
                            <strong>Topic Name</strong>
                        </th>
                        <th>
                            <strong>Status </strong>
                        </th>

                    </tr>
                </thead>
                <tbody>
                    {topic.map(item => (
                        <tr>
                            <td>
                                <strong>{item.position}</strong>
                            </td>
                            <td>{item.name}</td>
                            <td>{item.status}</td>
                            <td>
                                <Button onClick={() => updateRecord(item)} className="me-2"
                                    variant="info">
                                    Update
                                </Button>
                                <Button onClick={() => openModal(item)} className="me-2" variant="warning">
                                    Add Subtopics
                                </Button>

                               {subadminbar && <Button onClick={() => deleteRecord(item)} className="me-2" variant="danger">
                                    Delete
                                </Button>}



                            </td>


                        </tr>
                    ))}

                </tbody>
            </Table>

            <Modal className="modal fade" size="xl" show={postModal} onHide={setPostModal} >
                <div className="" role="document">
                    <div className="">
                        <form >
                            <div className="modal-header">
                               {subTopicData.name}
                                <button type="button" className="btn-close" onClick={closemodal} data-dismiss="modal"></button>
                            </div>
                            <div className="modal-body">

                                        <Suspense fallback={<div>Loading</div>}>
                                            <SubTopics subtopicprops={subTopicData}/>
                                            </Suspense>
                                   

                            </div>
                            
                        </form>

                    </div>
                </div>
            </Modal>


        </>
    )
}

export default Topics